import PanelRibbon from './PanelRibbon'

export default PanelRibbon
